import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface ICreateVasWizardRequestDto {
    socId: number,
    phone?: string,
    contactId?: number,
    flagId?: number,
}

/**
 * Подключение VAS
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v2#/Vas/cda801602f9a41eb5722ca3daaabf9d6
 */
export const createVasWizard = (params: ICreateVasWizardRequestDto): IRequest => ({
    uri: '/v2/vas/create-vas-wizard',
    method: 'POST',
    withAuth: true,
    withProvider: true,
    body: JSON.stringify(params),
});
